import { render, staticRenderFns } from "./CertificateSignup.vue?vue&type=template&id=0bb28fe0&scoped=true&"
import script from "./CertificateSignup.vue?vue&type=script&lang=js&"
export * from "./CertificateSignup.vue?vue&type=script&lang=js&"
import style0 from "./CertificateSignup.vue?vue&type=style&index=0&id=0bb28fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb28fe0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFlex,VRow,VSelect,VTextField})
